import React from "react"
import Paper from "material-ui/Paper"
//import { Link } from "react-router-dom";
import styled from "styled-components"
import { grey200 } from "material-ui/styles/colors"
import { Box, Card, Small, BackgroundImage } from "rebass"
import Currency from "./Currency"
import Header from "./Header"

const DefaultImage =
  "https://s3-ap-southeast-1.amazonaws.com/ola2-cms-staging/assets/1/content/ImageView-image-mobile-cLa.png"
const Container = styled(Box)`
  background-color: ${grey200};
`
//p={[3, 2, 2, 3]}
export const ProductCard = ({ product, itemWidth, showPrice }) => {
  let image = DefaultImage
  // if (product.photos && product.photos.length > 0) {
  //   image = product.photos[0];
  // }
  if (
    product.photos &&
    product.photos["*"] &&
    product.photos["*"].photos.length > 0
  ) {
    image = product.photos["*"].photos[0]
  } else if (
    product.photos &&
    product.photos["photo_set"] &&
    Object.keys(product.photos["photo_set"]).length > 0
  ) {
    const values = product.photos["photo_set"]
    const key = Object.keys(values)[0]
    image = values[key].photos.length > 0 ? values[key].photos[0] : DefaultImage
  }

  const { price, discount } = product
  const discountedPrice =
    discount < 1 ? price * (1 - discount) : price - discount
  return (
    <Paper zDepth={1} style={{ backgroundColor: "#eeeeee", width: itemWidth }}>
      <Card>
        <BackgroundImage src={image} ratio={1} width={itemWidth} />
        <Container p={[3, 2, 2, 2]}>
          <Header f={[0, 1, 1]} className="ql-font-Montserrat">
            {product.name}
          </Header>
          {showPrice && (
            <Small className="ql-font-OpenSans">
              <Currency value={discountedPrice} />
            </Small>
          )}
        </Container>
      </Card>
    </Paper>
  )
}



// WEBPACK FOOTER //
// ./src/contents/editorPreview/components/productcard/index.js